/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DuplicateSheetRowRequestFromJSON(json) {
    return DuplicateSheetRowRequestFromJSONTyped(json, false);
}
export function DuplicateSheetRowRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        targetId: json['targetId'],
    };
}
export function DuplicateSheetRowRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        targetId: value.targetId,
    };
}
